import * as v from "valibot";

import { rpcContract } from "../rpc";

export const changeEmailRpcContract = rpcContract({
  name: "changeEmail",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    token: v.string(),
    userId: v.string(),
  }),
  resultSchema: v.undefined(),
});

export type ChangeEmailParams = v.InferOutput<(typeof changeEmailRpcContract)["paramsSchema"]>;
export type ChangeEmailResult = v.InferOutput<(typeof changeEmailRpcContract)["resultSchema"]>;
